import React, { useState } from 'react'
import { Modal, Container, Spinner, Alert } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import { useTheme } from '@emotion/react'
import { PrimaryButton } from '@mmsg/louie'
import { Icon } from 'icons'
import { PrimaryLink } from 'components/styledComponents/link'
import {
  OnChangeOfContactMode,
  ResetStatusContactConsultant,
} from '../../actions/contactUsActions'
import { submitContactConsultantDetails } from '../../actions/contactUsActions'
import {
  addHoursToCurrentDate,
  fireInteractionCustomEvent,
} from '../../helpers'
import { BText } from 'components/styledComponents/text'
import * as E from './contactUsDialogElements'

const ContactUsDialog = (props) => {
  let isFormSubmitted = useSelector(
    (state) => state.contactUs && state.contactUs.isSubmitted
  )
  let isSubmissionInProgress = useSelector(
    (state) => state.contactUs && state.contactUs.isLoading
  )
  let hasSubmissionFailed = useSelector(
    (state) => state.contactUs && state.contactUs.hasSubmissionFailed
  )
  const [showDialog, setShowDialog] = useState(false)
  const [preferredDateTIme, setPreferredDateTime] = useState(
    addHoursToCurrentDate(25)
  )

  const OnShowDialog = () => {
    setShowDialog(true)
  }
  const OnHideDialog = () => {
    setShowDialog(false)
    dispatch(ResetStatusContactConsultant())
  }
  const [dialogLength, setDialogLength] = useState(0)

  let modeOfContact = ''
  let opportunityId = useSelector(
    (state) => state.authentication && state.authentication.opportunityId
  )

  const OnModeOfContactChanged = (e) => {
    dispatch(OnChangeOfContactMode(e.target.value))
    modeOfContact = e.target.value
    ValidateModeOfContact()
  }

  let formFields = {
    isQuestionTxtValid: false,
    isModeOfContactValid: false,
    isPreferredTimeValid: false,
  }

  let isValidDate = (date) => {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
      ? true
      : false
  }

  let ValidatePreferredDateTime = () => {
    let isValid = false
    if (modeOfContact === 'Email') {
      formFields.isPreferredTimeValid = true
      isValid = true
      return
    } else {
      if (isValidDate(document.getElementById('txtPreferredTime').value)) {
        isValid = true
      } else {
        isValid = false
      }
    }

    if (isValid) {
      let todaysDate = new Date()
      // seconds * minutes * hours * milliseconds = 1 day
      let day = 60 * 60 * 24 * 1000
      if (
        new Date(document.getElementById('txtPreferredTime').value) <
        new Date(todaysDate.getTime() + day)
      ) {
        document.getElementById('errorMsg-txtPreferredTime').style.display =
          'block'
        formFields.isPreferredTimeValid = false
      } else {
        document.getElementById('errorMsg-txtPreferredTime').style.display =
          'none'
        formFields.isPreferredTimeValid = true
      }
    } else {
      document.getElementById('errorMsg-txtPreferredTime').style.display =
        'block'
      formFields.isPreferredTimeValid = false
    }
  }

  let ValidateModeOfContact = () => {
    let isChecked = false
    var radioList = document.getElementsByName('modeOfContact')
    for (let i = 0; i < radioList.length; i++) {
      if (radioList[i].checked) {
        isChecked = true
        modeOfContact = radioList[i].value
        break
      }
    }

    if (!isChecked) {
      document.getElementById('errorMsg-modeOfContact').style.display = 'block'
      formFields.isModeOfContactValid = false
    } else {
      document.getElementById('errorMsg-modeOfContact').style.display = 'none'
      formFields.isModeOfContactValid = true
    }

    return isChecked
  }

  const OnSubmitContactConsultant = () => {
    let isFormDataValid = false
    if (ValidateModeOfContact()) {
      ValidatePreferredDateTime()
    }
    ValidateTxtQuestion()

    if (
      formFields.isQuestionTxtValid &&
      formFields.isModeOfContactValid &&
      formFields.isPreferredTimeValid
    ) {
      isFormDataValid = true
    }

    if (isFormDataValid) {
      // Make service call for submission
      let queryDetails = {
        message: encodeURI(document.getElementById('txtQuestion').value),
        preferredMethod: modeOfContact,
        preferredTime:
          modeOfContact === 'Phone'
            ? document.getElementById('txtPreferredTime').value
            : new Date(),
      }

      dispatch(submitContactConsultantDetails(opportunityId, queryDetails))
      fireInteractionCustomEvent({
        detail: {
          eventType: 'custom link click',
          data: {
            category: 'button',
            section: 'mylease',
            text: 'contact consultant',
            label: 'contact consultant',
          },
        },
      })
    }
  }

  const ValidateTxtQuestion = () => {
    setDialogLength(document.getElementById('txtQuestion').value.length)
    if (document.getElementById('txtQuestion').value === '') {
      document.getElementById('errorMsg-txtQuestion').style.display = 'block'
      formFields.isQuestionTxtValid = false
    } else {
      document.getElementById('errorMsg-txtQuestion').style.display = 'none'
      formFields.isQuestionTxtValid = true
    }
  }

  const dispatch = useDispatch()
  //dispatch(OnChangeOfContactMode('phone'))
  const modeOfCnt = useSelector((state) => state.contactUs)

  let consultant = useSelector((state) => state.consultant)
  const theme = useTheme()

  return (
    <span>
      {props.theme && props.theme === 'link' && (
        <PrimaryLink
          onClick={!props.disabled && OnShowDialog}
          inlineText={!!props.inlineText}
          disabled={props.disabled ? props.disabled : false}
        >
          {props.launchText}
        </PrimaryLink>
      )}
      {props.theme && props.theme !== 'link' && (
        <PrimaryButton
          disabled={!!props.disabled}
          invertColor={!!props.invertColor}
          className={props.className}
          onClick={OnShowDialog}
          extendInMob={props.extendInMob}
        >
          {props.launchText}
        </PrimaryButton>
      )}
      <Modal show={showDialog} onHide={OnHideDialog}>
        <Modal.Header closeButton>
          <Modal.Title className="text-uppercase width-100perc">
            <div className="text-center width-100perc">
              {!isFormSubmitted && (
                <h1 className="text-left">Contact your consultant</h1>
              )}
              {isFormSubmitted && (
                <div className="icon-header-section text-center pd-40">
                  <Icon iconType="phone" size={2} primary />
                </div>
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {isFormSubmitted && (
              <Container>
                <div className="font-weight-bold mb-2">
                  Contact request sent!
                </div>
                <div className="mb-2">
                  We’ve let {consultant.firstName} know you’d like them to get
                  in touch. You can expect to hear from them shortly.
                </div>
                <div className="mb-2">
                  In the meantime, you’ll receive a confirmation email in your
                  inbox.
                </div>
                <div className="d-flex justify-content-end  mb-2 mt-3">
                  <PrimaryButton onClick={OnHideDialog}>Got it</PrimaryButton>
                </div>
              </Container>
            )}
            {!isFormSubmitted && (
              <form>
                <div className="font-weight-bold mb-2">
                  Your consultant's contact details
                </div>
                <div className="mb-3">
                  <BText>Consultant name</BText>
                  <div>
                    {consultant.firstName} {consultant.lastName}
                  </div>
                </div>

                {consultant.email && (
                  <div className="mb-3">
                    <BText>Email</BText>
                    <div>
                      <PrimaryLink href={`mailto:${consultant.email}`}>
                        {consultant.email}
                      </PrimaryLink>
                    </div>
                  </div>
                )}

                {consultant.telephone && (
                  <div className="mb-4">
                    <BText>Phone number</BText>
                    <div className="font-weight-bold">
                      {consultant.telephone}
                    </div>
                  </div>
                )}

                <div className="font-weight-bold mb-1">
                  How would you like {consultant.firstName} to contact you?
                </div>

                <div className="mb-1">
                  Your consultant will contact you using the details we have on
                  file.
                </div>
                <div>(All fields are mandatory)</div>
                <br />
                <div className="mb-3">
                  <div>Select your preferred contact method</div>
                  <div>
                    <div className="mr-3">
                      <input
                        type="radio"
                        value="Phone"
                        name="modeOfContact"
                        onChange={OnModeOfContactChanged}
                      />{' '}
                      Phone
                    </div>
                    <input
                      type="radio"
                      value="Email"
                      name="modeOfContact"
                      onChange={OnModeOfContactChanged}
                    />{' '}
                    Email
                  </div>
                  <div id="errorMsg-modeOfContact" className="errorMsg">
                    Please select your preferred contact method
                  </div>
                </div>
                <div className="mb-3">
                  <span>What question would you like answered.</span>
                  <E.TextAreaLength>
                    {dialogLength == 150 && (
                      <E.WarningIcon
                        src="/images/icon-warningtriangle.svg"
                        alt=""
                      />
                    )}
                    {dialogLength}/200
                  </E.TextAreaLength>
                  <textarea
                    id="txtQuestion"
                    onChange={ValidateTxtQuestion}
                    maxLength="200"
                    placeholder="e.g. Can I add tinting to the car window?"
                    className="mt-2"
                    style={{'minHeight': '110px'}}
                  ></textarea>
                  <div id="errorMsg-txtQuestion" className="errorMsg">
                    Please outline your question in 200 characters or less.{' '}
                  </div>
                </div>
                {modeOfCnt &&
                  modeOfCnt.modeOfContact &&
                  modeOfCnt.modeOfContact === 'phone' && (
                    <div className="mb-3">
                      <div>What day and time works best for you.</div>

                      <input
                        type="datetime-local"
                        id="txtPreferredTime"
                        placeholder="Please select preferred time"
                        onChange={() => {
                          setPreferredDateTime(
                            document.getElementById('txtPreferredTime').value
                          )
                          ValidatePreferredDateTime()
                        }}
                        value={preferredDateTIme}
                      />
                      <small className="mb-3">
                        Note: Must be more than 24 hours from now.
                      </small>
                      <div id="errorMsg-txtPreferredTime" className="errorMsg">
                        Please select a date more than 24hrs from now.
                      </div>
                    </div>
                  )}
                {hasSubmissionFailed && (
                  <div className="mt-2 mb-2">
                    <Alert variant="danger">
                      Error submitting your request. Please try again
                    </Alert>
                  </div>
                )}
                <div>
                  {isSubmissionInProgress && (
                    <PrimaryButton extendinMob className="mt-2">
                      <>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Sending...
                      </>
                    </PrimaryButton>
                  )}
                  {!isSubmissionInProgress && (
                    <PrimaryButton
                      onClick={OnSubmitContactConsultant}
                      extendInMob
                    >
                      Send message
                    </PrimaryButton>
                  )}
                  &nbsp; &nbsp;
                  <PrimaryButton invertColor extendInMob onClick={OnHideDialog}>
                    Close
                  </PrimaryButton>
                </div>
              </form>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </span>
  )
}

function mapStateToProps(state) {
  return {
    contactUs: state.contactUs,
  }
}

export default connect(mapStateToProps)(ContactUsDialog)
